import SwitchButton from './components/SwitchButton';
export default SwitchButton;
//# sourceMappingURL=index.js.map